import { useAppSelector } from 'shared';

export const usePlacePageState = (
    () => useAppSelector((store) => store.placePage)
);
